import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { Stack, Tab, Tabs } from "@mui/material";
import { Routes } from "constants/routes";
import { useActionHook, useNavigate } from "hooks";
import { useDealActions } from "store";

import { ReactComponent as PortfolioIcon } from "../../assets/icons/portfolio-overview.svg";
import { AssetClassesTab } from "./AssetClassesTab";
import { IndexesTab } from "./IndexesTab";

export const AssetClasses = () => {
  const { getAssetClassesManagementAction, getAssetClassesPrivateIndexesAction } = useDealActions();
  const { pathname } = useLocation();

  const { data = [], loading, action: getTableData, setData } = useActionHook(getAssetClassesManagementAction);
  const { data: privateIndexesOption = [], action: getPrivateIndexes } = useActionHook(
    getAssetClassesPrivateIndexesAction
  );
  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  useEffect(() => {
    getTableData();
    getPrivateIndexes();
  }, []);

  const navigate = useNavigate();

  const goToAssetClasses = () => {
    navigate({ route: "assetClasses" });
  };

  const goToIndexes = () => {
    navigate({ route: "indexes" });
  };

  const handleExpandRow = (rowId: number) => {
    setExpandedRows((prev) => (prev.includes(rowId) ? prev.filter((i) => i !== rowId) : [...prev, rowId]));
  };

  const defaultTabValue = pathname.includes("indexes") ? "indexes" : "asset-classes";

  return (
    <Stack gap="16px" sx={{ flexGrow: 1, overflow: "hidden" }}>
      <Tabs value={defaultTabValue}>
        <Tab
          iconPosition="start"
          value="asset-classes"
          icon={<ListAltOutlinedIcon />}
          label="Asset classes"
          onClick={goToAssetClasses}
        />
        <Tab
          value="indexes"
          iconPosition="start"
          icon={<PortfolioIcon style={{ fill: "#0a3142", width: "15px", height: "17px" }} />}
          label="Indexes"
          onClick={goToIndexes}
        />
      </Tabs>
      <Switch>
        <Redirect exact from={Routes.assets} to={Routes.assetClasses} />
        <Route
          path={Routes.assetClasses}
          component={() => <AssetClassesTab data={data} loading={loading} setData={setData} />}
        />
        <Route
          path={Routes.indexes}
          component={() => (
            <IndexesTab
              data={data}
              loading={loading}
              setData={setData}
              expandedRows={expandedRows}
              onExpandRow={handleExpandRow}
              privateIndexesOption={privateIndexesOption}
            />
          )}
        />
      </Switch>
    </Stack>
  );
};
